import * as angular from 'angular';
import {IController} from "angular";

export class DeliveriesMapViewAgentsSideBarCtrl implements IController {
  selectedGroup: any;
  groupList: any;
  onChange: Function;

  selectedAgentsGroup: any;
  selectedAgentsType: any;
  branchIds: any;
  selectedAgent: any;
  selectedAgentRef: any;
  highlightedServiceId: any;
  isItineraryMode: any;
  onAgentSelect: Function;
  onAgentsGroupChange: Function;
  onHighlightedChanged: Function;
  onClose: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesMapViewAgentsSideBar', {
    bindings: {
      selectedAgentsGroup: '<',
      selectedAgentsType: '<',
      branchIds: '<?',
      selectedAgent: '<',
      selectedAgentRef: '<',
      highlightedServiceId: '<',
      isItineraryMode: '<',
      onAgentSelect: '&',
      onAgentsGroupChange: '&',
      onHighlightedChanged: '&',
      onClose: '&'
    },
    template: require('./deliveries-map-view-agents-side-bar.html').default,
    controller: DeliveriesMapViewAgentsSideBarCtrl
  });
